import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../../context/SocketContext";

export default function LiveRate(props) {
  const socket = useContext(SocketContext);

  const { symbol_id, buy_sell } = props;

  const [Ask, setAsk] = useState(0);
  const [Bid, setBid] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);

    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, []);

  const trade = (data) => {
    if (!data) return;

    const ask = data.Ask ?? 0;
    const bid = data.Bid ?? 0;

    // If bid is 0, replace with ask
    const finalBid = bid === 0 ? ask : bid;

    setAsk(ask);
    setBid(finalBid);
  };

  const displayValue = buy_sell === 0 ? Bid : Ask;

  return <div className="menuBuyPrice">{parseFloat(displayValue)}</div>;
}
